// extracted by mini-css-extract-plugin
export default {"subscriptionLoader":"Register_subscriptionLoader__UDvwE"};